import { useEffect } from "react";
import { useLocation } from "react-router";

export default function usePageTitle(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = `Stair Solutions - ${
      pathname.split("/")[1]!.charAt(0).toUpperCase() +
        pathname.split("/")[1]!.slice(1) || "login"
    }`;
  }, [pathname]);
}
